import React, {Component} from 'react';
import {
    Progress,
    Button,
    ListGroup,
    ListGroupItem,
    Modal,
    ModalBody,
    ModalHeader,
    Table,
    Card,
    Row,
	Col
} from 'reactstrap';
import axios from 'axios';

//Components
import CodeReview from './problemDetailsOptions/CodeReviewComponent';
import DisplayTestCase from './problemDetailsOptions/DisplayTestCaseComponent';
import DisplayCode from './problemDetailsOptions/DisplayCodeComponent';
import RequestReview from './problemDetailsOptions/RequestReviewComponent';
import ModalAlert from "../ModalAlertComponent";
import ProblemDetailsBreadcrumb from '../breadcrumbs/ProblemDetailsBreadcrumb';
import MarkdownRender from "../MarkdownRendererComponent";

//helpers
import {serverPath, thresholdForTestCase, convertDatetime, getExtension} from "../common";
import {renderTestCasesInformation} from "./submissionFunctions.js";

//style
import 'bootstrap/dist/css/bootstrap.css';
import '../../css/problemDetails.css';
import YesNoModal from "../YesNoModalComponent";
import {ReportModal} from "./ReportModalComponent";
import { CompanyImage } from '../CompanyImage';

//Route: /s/courses/:courseId/topic/:topicId/problem/:problemId
//Route for algorithm problems: /s/problem/:problemId
//              	         || /o/problem/:problemId
class ProblemDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            breadcrumbData: null,
            user: null,
            problemDetails: null,
            problemSubmissions: [],
            problemGraders: [],
            selectedGraderIndex: 0,
            courseProfessors: [],
            reports: [],
            //requestReview
            requestReviewOpen: false,
            requestReviewSubmission: null,

            //codeReview
            codeReviewOpen: false,
            codeReviewSubmission: null,

            //displayTestCase
            displayTestCaseOpen: false,
            testCase: null,

            //displayCode
            displayCodeOpen: false,
            displayCodeSubmission: null,

            //file upload
            file: null,
            showSubmitModal: false,
            graderMessage: "Ocenjivanje u toku",
            graderResult: null,

            //modal alert
            modalAlertOpen: false,
            modalAlertMessage: "",

            //yesNo modal
            yesNoModalData: null,
            yesNoModalOpen: false,

            //remove review req
            submissionToUnreview: null,

            //report
            canSubmitReport: true,
        };

        this.toggleSubmitModal = this.toggleSubmitModal.bind(this);
        this.hideRequestReview = this.hideRequestReview.bind(this);
        this.hideCodeReview = this.hideCodeReview.bind(this);
        this.hideTestCase = this.hideTestCase.bind(this);
        this.hideCode = this.hideCode.bind(this);
        this.hideModalAlert = this.hideModalAlert.bind(this);
        this.toggleYesNoModal = this.toggleYesNoModal.bind(this);
        this.handleDontRemoveRequest = this.handleDontRemoveRequest.bind(this);
        this.handleRemoveRequest = this.handleRemoveRequest.bind(this);

    }

    getPrefix() {
        if (this.props.match.params.prefix) {
            return this.props.match.params.prefix;
        }
        else return "s";
    }

    getData() {
        //setting them to "null" initially, so if route is /s/problem/:problemId they stay "null" because of backend
        let courseId = "null";
        let topicId = "null";
        if (this.props.match.params.topicId) {
            courseId = this.props.match.params.courseId;
            topicId = this.props.match.params.topicId;
        }
        const urlSplited = this.props.match.url.split("/");
        const isAlgorithmsPage = urlSplited[2] === "problem";
        this.setState({
            isAlgorithmsPage: isAlgorithmsPage,
        });
        let service;
        if (this.getPrefix() === "o") {
            service = "otherUserService.php";
        }
        else {
            service = "studentService.php";
        }
        axios.get(serverPath + service, {
            params: {
                action: 'getProblemDetailsComponentData',
                courseId: courseId,
                topicId: topicId,
                problemId: this.props.match.params.problemId,
            }
        }).then((response) => {
            var courseName = "null";
            var topicName = "null";
            if (response.data.breadcrumbData.course) {
                courseName = response.data.breadcrumbData.course.name;
                topicName = response.data.breadcrumbData.topic;
            }

            var breadcrumbDataTmp = {
                courseName: courseName,
                topicName: topicName,
                problemName: response.data.breadcrumbData.problem.name,
                courseId: courseId,
                topicId: topicId,
                userPrefix: this.getPrefix(),
            };
            this.setState({
                breadcrumbData: breadcrumbDataTmp,
                user: response.data.authData,
                problemSubmissions: response.data.problemSubmissions,
                problemDetails: response.data.problemDetails.problemDetails,
                problemGraders: response.data.problemDetails.graders,
				selectedGrader: 0,
				companyData: response.data.companyData,
                courseProfessors: response.data.professors,
                reports: response.data.reports,
                canSubmitReport: response.data.canSubmitReport,
            });
        });

    }

    componentDidMount() {
        this.getData();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.match.params.courseId !== this.props.match.params.courseId ||
            prevProps.match.params.topicId !== this.props.match.params.topicId ||
            prevProps.match.params.problemId !== this.props.match.params.problemId) {
            this.getData();
        }
    };

    /********************* MODAL ALERT  *********************/
    showModalAlert(message) {
        this.setState({
            modalAlertMessage: message,
            modalAlertOpen: true
        });
    }

    hideModalAlert() {
        this.setState({
            modalAlertOpen: false,
            modalAlertMessage: ""
        });
    }

    /***********************YESNO MODAL***********************/
    toggleYesNoModal() {
        const self = this;
        this.setState({
            yesNoModalOpen: !self.state.yesNoModalOpen
        })
    }

//not an error, empty function
    handleDontRemoveRequest() {
    }

    handleRemoveRequest() {
        const params = new URLSearchParams();
        let tmp = this.state.submissionToUnreview;
        params.append('submissionId', tmp.submissionId);
        params.append('action', 'removeRequestReview');
        axios.post(serverPath + "submissionService.php", params)
            .then((resp) => {
                if (!resp.data) {
                    alert("Zahtev za uklananje nije uspeo. Pokušajte ponovo. Ukoliko se ponovi, kontaktirajte administratora.");
                }
                else {
                    //this is done so render is triggered and proper icon is set
                    tmp.requestedReview = false;
                    tmp.requestedText = null;
                    tmp.reviewer = null;
                    this.setState({
                        submissionToUnreview: null,
                    })
                }
            })
    }

    /************** OPTION 1: REVIEW REQUEST  ***************/
    renderRequestReview(submission) {
        var title = "";
        if (submission.codeReview !== null) {
            title = "Komentar je već zatražen.\n";
            if (submission.requestText !== null && submission.requestText !== "")
                title += "Propratni tekst: " + submission.requestText;

            return (<span title={title} className={'fa fa-comment inactive'}/>);
        } else if (parseInt(submission.requestedReview, 10)) {
            title = "Ukloni traženje komenatara.\n";

            return (
                <span title={title} className={'fa fa-times-circle active'}
                      id={"requestReview" + submission.submissionId}
                      onClick={() => this.showRemoveRequestedReview(submission)}
                />
            );
        } else {
            return (
                <span title="Zatraži komentar" className={'fa fa-comment-o active'}
                      id={"requestReview" + submission.submissionId}
                      onClick={() => this.showRequestReview(submission)}>
                           </span>
            );
        }
    }

    showRequestReview(submission) {
        this.setState({
            requestReviewSubmission: submission,
            requestReviewOpen: true
        });
    }

    hideRequestReview(requested, requestText) {
        //this triggers rendering
        this.state.requestReviewSubmission.requestedReview = requested;
        this.state.requestReviewSubmission.requestText = requestText;
        this.setState({
            requestReviewOpen: false,
            requestReviewSubmission: null
        });
    }

    showRemoveRequestedReview(submission) {
        let requestText = null;
        if (submission.requestText !== null && submission.requestText !== "")
            requestText = <h2>Vaš tekst: {submission.requestText}</h2>;
        let bodyText =
            <div>
                {requestText}
                <h5>Da li ste sigurni da želite da uklonite traženje komenatara na Vaš kod?</h5>
            </div>;
        this.setState({
            yesNoModalData: {
                title: "Uklonite traženje komentara",
                body: bodyText,
                yesText: "Da, ukloni",
                noText: "Ne uklanjaj",
                onYes: this.handleRemoveRequest,
                onNo: this.handleDontRemoveRequest,
                toggle: this.toggleYesNoModal
            },
            submissionToUnreview: submission,
        }, () => {
            this.toggleYesNoModal()
        })
    }

    /************** OPTION 2: SHOW CODE REVIEW *************/
    renderCodeReview(submission) {
        if (submission.codeReview !== null) {
            var classes = "fa fa-comments active";
            if (submission.seenReview === 0)
                classes += " notSeenReview";
            return (<span title="Pogledaj komentar" className={classes}
                          onClick={() => {
                              this.showCodeReview(submission)
                          }}
            />)
        }
        else {
            return (<span title="Trenutno nema komentara" className={'fa fa-comments-o inactive'}/>);
        }
    }

    showCodeReview(submission) {
        if (submission.codeReview !== null) {
            if (submission.seenReview === 0) {//reading review for the first time
                var params = new FormData();
                params.append("action", "seenReview");
                params.append("id", submission.submissionId);
                axios.post(serverPath + "notificationService.php", params);//set seenReview to 1 in db
                submission.seenReview = 1;
                this.props.removeNotification(submission.submissionId);
            }
            if (typeof submission.codeReview === "string")
                submission.codeReview = JSON.parse(submission.codeReview);

            this.setState({
                codeReviewSubmission: submission,
                codeReviewOpen: true
            });
        }
    }

    hideCodeReview() {
        this.setState({
            codeReviewOpen: false,
            codeReviewSubmission: null
        });
    }

    /************** OPTION 3: ASK FOR Test Case ************/
    getWrongTestCase(submission) {
        var self = this;
        axios.get(serverPath + "submissionService.php", {
            params: {
                action: 'getWrongTestCase',
                submissionId: submission.submissionId
            }
        })
            .then(function (response) {
                var tc = response.data;
                if (!tc || typeof tc === "string") {
                    self.showModalAlert(response.data);
                    return;
                }
                self.setState({
                    testCase: tc,
                    displayTestCaseOpen: true
                });
            });
    }

    hideTestCase() {
        this.setState({
            displayTestCaseOpen: false,
            testCase: null
        });
    }

    renderAskForTestCase(submission) {
        if (this.props.match.params.topicId) {
            if (submission.score === 100) {
                return (
                    <div className={'col-1'}>
                            <span title="Svi test primeri su prosli."
                                  className={'fa fa-question-circle-o inactive'}/>
                    </div>
                );
            }
            else if (submission.score >= thresholdForTestCase) {
                return (
                    <div className={'col-1'}>
                            <span title="Zatraži test primer koji nije prošao"
                                  className={'fa fa-question-circle active'}
                                  onClick={() => this.getWrongTestCase(submission)}/>
                    </div>
                );
            }
            else {
                return (
                    <div className={'col-1'}>
                            <span
                                title={"Da biste videli test primere, morate imati bar " + thresholdForTestCase + " poena."}
                                className={'fa fa-question-circle-o inactive'}/>
                    </div>
                );
            }
        }
        else {
            return (null);
        }
    }

    /************** OPTION 4: SHOW CODE REVIEW *************/
    showCode(submission) {
        this.setState({
            displayCodeSubmission: submission,
            displayCodeOpen: true
        });
    }

    hideCode() {
        this.setState({
            displayCodeOpen: false,
            displayCodeSubmission: null
        });
    }

    /****************** RENDER HELPERS *********************/

    /**
     *
     * @returns button for downloading file template if one is available
     */
    renderFileTemplate() {
        if (this.state.problemDetails.templateFileContent !== null) {
            var templateFile = "data:application/octet-stream," + encodeURIComponent(this.state.problemDetails.templateFileContent);

            let extension = getExtension(this.state.problemGraders[this.state.selectedGraderIndex].id);

            let fileName = this.state.problemDetails.name.toLowerCase().replace(' ', '_')
                .replace('ć', 'c').replace('č', 'c').replace('š', 's').replace('đ', 'dj').replace('ž', 'z') + extension;

            return (
                <div className={'col text-center'}>
                    {<a href={templateFile} download={fileName}><Button color={'primary'}>Preuzmi šablon</Button></a>}
                </div>
            );
        }
        else {
            return null;
        }
    }

    /**
     *
     * @returns list of all student's submissions for this problem
     */
    renderSubmissions() {
        if (this.state.problemSubmissions === null) {
            return null;
        }
        else {
            var submissions = this.state.problemSubmissions.map((submission, index) => {
                if (typeof submission.score === "string")
                    submission.score = parseInt(submission.score, 10);
                return (
                    <ListGroupItem index={index}>
                        <div className={'row'}>
                            <div className={'col-1'}> {index + 1}</div>
                            <div className={'col-3'}> {convertDatetime(submission.timestamp)}</div>
                            <div className={'col-3'}>
                                <Progress value={submission.score}
                                          color={submission.score === 100 ? 'success' : submission.score >= 50 ? 'warning' : 'info'}>
                                    {submission.score}%
                                </Progress>
                            </div>
                            {
                                !this.state.isAlgorithmsPage
                                && <div className={'col-1'}> {this.renderRequestReview(submission)} </div>
                            }
                            {
                                !this.state.isAlgorithmsPage
                                && <div className={'col-1'}> {this.renderCodeReview(submission)} </div>
                            }
                            {this.renderAskForTestCase(submission)}
                            <div className={'col-1'}>
                                <span title="Pogledaj kod" className={'fa fa-code'}
                                      onClick={() => this.showCode(submission)}/>
                            </div>
                        </div>
                    </ListGroupItem>
                );
            });
            return submissions;
        }

    }

    renderProblemGraders() {
        var graders = this.state.problemGraders.map((grader, index) => {
            return (
                <div className={'col text-center'}>
                    <input type={'radio'} id={"radio" + index}
                           name={'grader'} value={grader}
                           defaultChecked={index === 0}
                           onChange={(e) => {

                               this.setState({
                                   selectedGraderIndex: index,
                               })
                           }
                           }/> <label for={"radio" + index}>{grader.name}</label>
                </div>
            );
        });
        return graders;
    }

    /***********************SUBMIT**************************/
    handleFileSelect(e) {
        this.setState({
            file: e.target.files[0],
        });
    }

    /*
    * @param submissionId
    * @param graderTaskId
    * checks for status of submission with submissionId using graderTaskId for getting the info
    * */
    query_submission(submissionId, graderTaskId) {
        var self = this;

        axios.get(serverPath + "submissionService.php", {
            params: {
                action: 'getTaskStatus',
                graderTaskId: graderTaskId,
                submissionId: submissionId,
            }
        }).then(function (response) {
            if (response.data.state === "finished" ||
                response.data.state === "compile_err" ||
                response.data.state === "malformed_request" ||
                response.data.state === "internal_error") {
                self.setState({graderMessage: "Ocenjivanje završeno", graderResult: response.data,});

                axios.get(serverPath + "submissionService.php", {
                    params: {
                        action: 'getSubmissionDetails',
                        submissionId: submissionId,
                    }
                }).then(function (response) {
                    self.setState({
                        problemSubmissions: self.state.problemSubmissions.concat(response.data),
                    });
                });
            }
            else {
                setInterval(self.query_submission(submissionId, graderTaskId), 200);
            }
        });
    }

    handleFileSubmit() {

        var self = this;
        const params = new FormData();

        params.append('action', 'postSubmission');
        params.append('problemId', this.props.match.params.problemId);
        params.append('graderId', this.state.problemGraders[this.state.selectedGraderIndex].id);
        params.append('graderName', this.state.problemGraders[this.state.selectedGraderIndex].name);
        params.append('file', this.state.file);
        params.append('template', this.state.problemDetails.templateFileContent);

        axios.post(serverPath + "submissionService.php", params, {}).then(
            (response) => {
                if (response.data.hasOwnProperty('message')) {
                    if (response.data.message === "Template mismatch") {
                        this.setState({
                            graderMessage: "Niste iskoristili zadati šablon! Ne smete menjati ništa osim tela naznačene " +
                                "funkcije. Pokušajte ponovo.",
                            graderResult: null
                        });
                    }
                    else if (response.data.message === "Problem with upload or storing of file") {
                        this.setState({
                            graderMessage: "Greška na serveru(Problem with upload or storing of file)." +
                                " Ukoliko se ponovi molimo kontaktirajte nastavnika/administratora.",
                            graderResult: null
                        });
                    }
                }
                else {
                    const submissionId = response.data.submissionId;
                    const graderTaskId = response.data.graderTaskId;
                    if (graderTaskId !== '') {
                        self.query_submission(submissionId, graderTaskId);
                    }
                }
            }
        );
    }

    handleSubmitClick(extension) {

        if (this.state.file === null) {
            this.showModalAlert("Niste izabrali fajl!");
            return;
        }
        var indexOfDot = this.state.file.name.lastIndexOf(".");
        if (indexOfDot === -1) {
            this.showModalAlert("Loš fajl");
            return;
        }
        /*
        this check is necessary because, in case of multiple graders, user can select one grader, upload file for that grader
         and then change the grader and try to submit*/
        if (this.state.file.name.substr(indexOfDot,) !== extension) {
            this.showModalAlert("Ekstenzija fajla se ne poklapa sa izabranim ocenjivačem!");
            return;
        }
        this.handleFileSubmit();
        this.toggleSubmitModal();
    }

    toggleSubmitModal() {
        this.setState({
            showSubmitModal: !this.state.showSubmitModal,
        });
        /*when this is set at the same time as toggle, it is visible while modal is closing, so this fixes it
        * NOTE
        * If ever a bug is presented in which grading is done but for whichever reason nothing is shown
        * (message stays Ocenjivanje u toku) try setting smaller timeout here or removing it completely.
        * Theoretically it is possible that from toggling modal to presenting data takes less then 200ms
        * (or whatever number stays here)
        * */
        setTimeout(() => {
            this.setState({
                graderResult: null,
                graderMessage: "Ocenjivanje u toku",
            })
        }, 200);
    }

    showProblemDetails() {
        if (this.state.problemDetails === null) {
            return null;
        }
        else {
            let extension = getExtension(this.state.problemGraders[this.state.selectedGraderIndex].id);
            return (
                <React.Fragment>
                    <hr/>
                    <div className="card-container">
                        <Card id="problem">
                            <div className={'container-fluid mt-3'}>
                                <Row>
                                    <Col xs={8}>
                                        <h3>{this.state.problemDetails.name}</h3>
                                    </Col>

                                    <Col>
                                        <ReportModal problemId={this.props.match.params.problemId}
                                                     existingReports={this.state.reports}
                                                     user={this.state.user}
                                                     canSubmitReport={this.state.canSubmitReport}/>
                                    </Col>
								{
									this.state.isAlgorithmsPage &&
									this.state.companyData &&
									<div id='companyData'>
                                        Autor zadatka:<br/>
										{CompanyImage(this.state.companyData)}
									</div>
									
								}
                                </Row>
                            </div>
                            <div className="problemText">
                                <MarkdownRender source={this.state.problemDetails.text} escapeHtml={false}/>
                                <div className={'container-fluid'}>
                                    <div className={'row'}>
                                        <Table className={'text-center'} size={'sm'}>
                                            <thead>
                                            <tr>
                                                <th className={'col-6'}> Programski jezici</th>
                                                <th className={'col'}> Vremensko ograničenje</th>
                                                <th className={'col'}> Memorijsko ograničenje</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td> {this.renderProblemGraders()} </td>
                                                <td><span
                                                    className="fa fa-clock-o"/> {this.state.problemDetails.timeLimit} ms
                                                </td>
                                                <td><span
                                                    className="fa fa-database"/> {this.state.problemDetails.memoryLimit / 1024 / 1024} MB
                                                </td>
                                            </tr>
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </div>
                            <div className={'row mt-2 mb-2'}>
                                {this.renderFileTemplate()}
                                <div className={'col-6'}>
                                    <input type="file" accept={extension} onChange={(e) => {
                                        this.handleFileSelect(e)
                                    }}/>
                                </div>
                                <div className={'col'}>
                                    <Button color={'primary'} onClick={() => {
                                        this.handleSubmitClick(extension)
                                    }}>Pošalji rešenje</Button>
                                </div>
                            </div>
                        </Card>
                    </div>

                    <hr/>
                    <div className="card-container">
                        <Card>
                            <h3> Svi pokušaji rešavanja ovog zadatka </h3>
                            <ListGroup style={{'text-align': 'center'}}>
                                <ListGroupItem>
                                    <div className={'row'}>
                                        <div className={'col-1'}>#</div>
                                        <div className={'col-3'}> Vreme</div>
                                        <div className={'col-3'}> Poeni</div>
                                        <div className={'col-4'}> Opcije</div>
                                    </div>
                                </ListGroupItem>
                                {this.renderSubmissions()}
                            </ListGroup>
                        </Card>
                    </div>
                </React.Fragment>
            );
        }
    }

    /************************ RENDER ***********************/

    render() {
        return (
            <div className="row">
                <div className="col-10 offset-1">
                    <ProblemDetailsBreadcrumb data={this.state.breadcrumbData}/>

                    {this.showProblemDetails()}

                    {
                        !this.state.isAlgorithmsPage
                        && <RequestReview showPopover={this.state.requestReviewOpen}
                                          submission={this.state.requestReviewSubmission}
                                          closePopoverHandler={this.hideRequestReview}
                                          courseProfessors={this.state.courseProfessors}/>

                    }
                    {
                        !this.state.isAlgorithmsPage
                        &&
                        <CodeReview showModal={this.state.codeReviewOpen} submission={this.state.codeReviewSubmission}
                                    closeModalHandler={this.hideCodeReview}/>
                    }
                    <DisplayTestCase showModal={this.state.displayTestCaseOpen} testCase={this.state.testCase}
                                     closeModalHandler={this.hideTestCase}/>

                    <DisplayCode showModal={this.state.displayCodeOpen} submission={this.state.displayCodeSubmission}
                                 closeModalHandler={this.hideCode}/>

                    <Modal isOpen={this.state.showSubmitModal} toggle={this.toggleSubmitModal}
                           className={'submitModal'}>
                        <ModalHeader toggle={this.toggleSubmitModal}>
                            Rezultati testiranja
                        </ModalHeader>
                        <ModalBody>
                            <div className={'container-fluid'}>
                                <div className={'row'}>
                                    <div className={'col text-center'}>
                                        {this.state.graderMessage !== "Ocenjivanje završeno" ? this.state.graderMessage : ""}
                                    </div>
                                </div>
                                {renderTestCasesInformation(this.state.graderMessage, this.state.graderResult)}
                            </div>
                        </ModalBody>
                    </Modal>

                    <ModalAlert showModal={this.state.modalAlertOpen} message={this.state.modalAlertMessage}
                                closeModalHandler={this.hideModalAlert}/>

                    <YesNoModal isOpen={this.state.yesNoModalOpen}
                                {...this.state.yesNoModalData}/>

                </div>
            </div>
        );
    }


}

export default ProblemDetails;
